import { render } from "./VerifyAct.vue?vue&type=template&id=51629e98"
import script from "./VerifyAct.vue?vue&type=script&lang=js"
export * from "./VerifyAct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__